var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralKnowledge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.87 464.87",
    style: {
      enableBackground: "new 0 0 464.87 464.87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.86,280.931c42.008-17.061,69.234-58.161,68.559-103.496c0-62.309-53.832-113-120-113s-120,50.691-120,113 c-0.675,45.335,26.55,86.435,68.559,103.496l0.93,0.504l6.353,10.424c-11.342,6.565-15.214,21.081-8.65,32.422 c0.863,1.491,1.886,2.884,3.051,4.154c-8.894,9.75-8.201,24.863,1.548,33.758c4.429,4.04,10.215,6.268,16.209,6.242h64 c13.197,0.058,23.942-10.594,24-23.791c0.026-5.995-2.202-11.781-6.242-16.209c8.859-9.657,8.211-24.667-1.446-33.525 c-1.27-1.165-2.662-2.188-4.154-3.051l6.353-10.424L283.86,280.931z M264.418,352.435h-64c-4.418,0-8-3.582-8-8s3.582-8,8-8h64 c4.418,0,8,3.582,8,8S268.836,352.435,264.418,352.435z M264.418,320.435h-64c-4.418,0-8-3.582-8-8s3.582-8,8-8h64 c4.418,0,8,3.582,8,8S268.836,320.435,264.418,320.435z M276.598,266.666l-3.199,1.738c-1.238,0.675-2.277,1.664-3.012,2.867 l-10.461,17.164h-3.508v-60.688l37.656-37.656l-11.312-11.313l-40,40c-1.5,1.5-2.343,3.534-2.344,5.656v64h-16v-64 c-0.001-2.122-0.844-4.156-2.344-5.656l-40-40l-11.312,11.312l37.656,37.656v60.688h-3.508l-10.461-17.164 c-0.735-1.203-1.774-2.192-3.012-2.867l-3.199-1.738c-0.257-0.137-0.52-0.261-0.789-0.371 c-36.169-14.551-59.637-49.878-59.031-88.859c0-53.484,46.652-97,104-97c57.348,0,104,43.516,104,97 c0.606,38.981-22.863,74.308-59.031,88.859C277.118,266.405,276.854,266.529,276.598,266.666z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.417,
    y: 57.602,
    transform: "matrix(0.4472 -0.8944 0.8944 0.4472 -26.6442 125.7576)",
    width: 16,
    height: 53.664
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.101,
    y: 76.448,
    transform: "matrix(0.9486 -0.3164 0.3164 0.9486 -7.4586 122.956)",
    width: 53.664,
    height: 16
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.418,
    y: 168.435,
    width: 48,
    height: 16
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384.418,
    y: 168.435,
    width: 48,
    height: 16
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.588,
    y: 276.433,
    transform: "matrix(0.8944 -0.4472 0.4472 0.8944 -117.8667 69.5699)",
    width: 53.664,
    height: 16
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 368.424,
    y: 257.615,
    transform: "matrix(0.4472 -0.8944 0.8944 0.4472 -46.3343 493.9232)",
    width: 16,
    height: 53.664
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.418,
    y: 8.435,
    width: 16,
    height: 40
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M464.418,384.435v-16c-104.371,0-215.281,25.23-215.996,72h-32.008c-0.715-46.77-111.625-72-215.996-72v16 c117.199,0,199.037,29.414,199.957,56H0.418v16h464v-16H264.461C265.381,413.849,347.219,384.435,464.418,384.435z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.435,
    y: 344.309,
    transform: "matrix(0.0526 -0.9986 0.9986 0.0526 -347.4305 474.6621)",
    width: 16,
    height: 152.24
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 312.314,
    y: 412.43,
    transform: "matrix(0.9986 -0.0527 0.0527 0.9986 -21.6328 21.071)",
    width: 152.24,
    height: 16
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null)), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralKnowledge);
export default __webpack_public_path__ + "static/media/GeneralKnowledge.f591a67e.svg";
export { ForwardRef as ReactComponent };